var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("v-tour", {
        attrs: {
          name: "setting",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Add Global Variable"),
            visible: _vm.addDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { ref: "globalVariableForm", attrs: { "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Key") } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.globalVariableForm.key,
                      callback: function($$v) {
                        _vm.$set(_vm.globalVariableForm, "key", $$v)
                      },
                      expression: "globalVariableForm.key"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Value") } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.globalVariableForm.value,
                      callback: function($$v) {
                        _vm.$set(_vm.globalVariableForm, "value", $$v)
                      },
                      expression: "globalVariableForm.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Remark") } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.globalVariableForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.globalVariableForm, "remark", $$v)
                      },
                      expression: "globalVariableForm.remark"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { "text-align": "right" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function($event) {
                            _vm.addDialogVisible = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.addGlobalVariableHandle(false)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Save")))]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.tabActiveHandle },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("General"), name: "general" } },
            [
              _c(
                "el-form",
                {
                  ref: "setting-form",
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.userInfo,
                    "label-width": "200px",
                    rules: _vm.rulesNotification,
                    "inline-message": ""
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "username", label: _vm.$t("Username") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.userInfo.username,
                          callback: function($$v) {
                            _vm.$set(_vm.userInfo, "username", $$v)
                          },
                          expression: "userInfo.username"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Allow Sending Statistics") } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#67C23A",
                          "inactive-color": "#909399"
                        },
                        on: { change: _vm.onAllowSendingStatisticsChange },
                        model: {
                          value: _vm.isAllowSendingStatistics,
                          callback: function($$v) {
                            _vm.isAllowSendingStatistics = $$v
                          },
                          expression: "isAllowSendingStatistics"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Enable Tutorial") } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#67C23A",
                          "inactive-color": "#909399"
                        },
                        on: { change: _vm.onEnableTutorialChange },
                        model: {
                          value: _vm.isEnableTutorial,
                          callback: function($$v) {
                            _vm.isEnableTutorial = $$v
                          },
                          expression: "isEnableTutorial"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.saveUserInfo }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("Change Password"),
                name: "change-password"
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "change-password-form",
                  staticClass: "change-password-form",
                  attrs: {
                    model: _vm.userInfo,
                    "label-width": "200px",
                    "inline-message": ""
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "password",
                        label: _vm.$t("Password"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "password",
                          placeholder: _vm.$t("Password")
                        },
                        model: {
                          value: _vm.userInfo.password,
                          callback: function($$v) {
                            _vm.$set(_vm.userInfo, "password", $$v)
                          },
                          expression: "userInfo.password"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "confirm_password",
                        label: _vm.$t("Confirm Password"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "password",
                          placeholder: _vm.$t("Confirm Password")
                        },
                        model: {
                          value: _vm.userInfo.confirm_password,
                          callback: function($$v) {
                            _vm.$set(_vm.userInfo, "confirm_password", $$v)
                          },
                          expression: "userInfo.confirm_password"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.changePassword }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Notifications"), name: "notify" } },
            [
              _c(
                "el-form",
                {
                  ref: "setting-form",
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.userInfo,
                    "label-width": "200px",
                    rules: _vm.rulesNotification,
                    "inline-message": ""
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Notification Trigger Timing") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.userInfo.setting.notification_trigger,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.userInfo.setting,
                                "notification_trigger",
                                $$v
                              )
                            },
                            expression: "userInfo.setting.notification_trigger"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: "notification_trigger_on_task_end"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("On Task End")) + " ")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: "notification_trigger_on_task_error"
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("On Task Error")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "notification_trigger_never" } },
                            [_vm._v(" " + _vm._s(_vm.$t("Never")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "enabledNotifications",
                        label: _vm.$t("消息通知方式")
                      }
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.userInfo.setting.enabled_notifications,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.userInfo.setting,
                                "enabled_notifications",
                                $$v
                              )
                            },
                            expression: "userInfo.setting.enabled_notifications"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { label: "notification_type_mail" } },
                            [_vm._v(_vm._s(_vm.$t("邮件")))]
                          ),
                          _c(
                            "el-checkbox",
                            { attrs: { label: "notification_type_ding_talk" } },
                            [_vm._v(_vm._s(_vm.$t("钉钉")))]
                          ),
                          _c(
                            "el-checkbox",
                            { attrs: { label: "notification_type_wechat" } },
                            [_vm._v(_vm._s(_vm.$t("企业微信")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "email", label: _vm.$t("Email") } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: _vm.$t("Email") },
                        model: {
                          value: _vm.userInfo.email,
                          callback: function($$v) {
                            _vm.$set(_vm.userInfo, "email", $$v)
                          },
                          expression: "userInfo.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "setting.ding_talk_robot_webhook",
                        label: _vm.$t("DingTalk Robot Webhook")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("DingTalk Robot Webhook")
                        },
                        model: {
                          value: _vm.userInfo.setting.ding_talk_robot_webhook,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userInfo.setting,
                              "ding_talk_robot_webhook",
                              $$v
                            )
                          },
                          expression: "userInfo.setting.ding_talk_robot_webhook"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "setting.wechat_robot_webhook",
                        label: _vm.$t("Wechat Robot Webhook")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: _vm.$t("Wechat Robot Webhook") },
                        model: {
                          value: _vm.userInfo.setting.wechat_robot_webhook,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userInfo.setting,
                              "wechat_robot_webhook",
                              $$v
                            )
                          },
                          expression: "userInfo.setting.wechat_robot_webhook"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.saveUserInfo }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Log"), name: "log" } },
            [
              _c(
                "el-form",
                {
                  ref: "log-form",
                  staticClass: "setting-form",
                  attrs: {
                    model: _vm.userInfo,
                    "label-width": "200px",
                    rules: _vm.rulesLog,
                    "inline-message": ""
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Error Regex Pattern"),
                        prop: "setting.error_regex_pattern"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder:
                            _vm.$t("By default: ") +
                            _vm.$utils.log.errorRegex.source,
                          clearable: ""
                        },
                        model: {
                          value: _vm.userInfo.setting.error_regex_pattern,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userInfo.setting,
                              "error_regex_pattern",
                              $$v
                            )
                          },
                          expression: "userInfo.setting.error_regex_pattern"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Max Error Logs Display"),
                        prop: "setting.max_error_log"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.userInfo.setting.max_error_log,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.userInfo.setting,
                                "max_error_log",
                                $$v
                              )
                            },
                            expression: "userInfo.setting.max_error_log"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 100, label: "100" }
                          }),
                          _c("el-option", {
                            attrs: { value: 500, label: "500" }
                          }),
                          _c("el-option", {
                            attrs: { value: 1000, label: "1000" }
                          }),
                          _c("el-option", {
                            attrs: { value: 5000, label: "5000" }
                          }),
                          _c("el-option", {
                            attrs: { value: 10000, label: "10000" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Log Expire Duration"),
                        prop: "setting.log_expire_duration"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.userInfo.setting.log_expire_duration,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.userInfo.setting,
                                "log_expire_duration",
                                $$v
                              )
                            },
                            expression: "userInfo.setting.log_expire_duration"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 0, label: _vm.$t("No Expire") }
                          }),
                          _c("el-option", {
                            attrs: { value: 3600, label: "1 " + _vm.$t("Hour") }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 6,
                              label: "6 " + _vm.$t("Hours")
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 12,
                              label: "12 " + _vm.$t("Hours")
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 24,
                              label: "1 " + _vm.$t("Day")
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 24 * 7,
                              label: "7 " + _vm.$t("Days")
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 24 * 14,
                              label: "14 " + _vm.$t("Days")
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 24 * 30,
                              label: "30 " + _vm.$t("Days")
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 24 * 30 * 3,
                              label: "90 " + _vm.$t("Days")
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              value: 3600 * 24 * 30 * 6,
                              label: "180 " + _vm.$t("Days")
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.saveUserInfo }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "API Token", name: "api-token" } },
            [
              _c("input", { attrs: { id: "clipboard" } }),
              _c("el-alert", { attrs: { type: "primary" } }),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onAddApiToken }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Add")) + " ")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                { attrs: { data: _vm.apiTokens, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "Token" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.visible
                                    ? scope.row.token
                                    : _vm.getMaskValue(scope.row.token)
                                ) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("Action"), width: "200px" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-button", {
                              attrs: {
                                type: "warning",
                                size: "mini",
                                icon: "el-icon-view",
                                circle: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTokenVisible(scope.row)
                                }
                              }
                            }),
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                icon: "el-icon-document-copy",
                                circle: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.copyToken(scope.row.token)
                                }
                              }
                            }),
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-delete",
                                circle: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onDeleteToken(scope.row)
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("Global Variable"),
                name: "global-variable"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "10px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        icon: "el-icon-plus",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addGlobalVariableHandle(true)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Add")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "success" },
                      on: { click: _vm.saveUserInfo }
                    },
                    [_vm._v(_vm._s(_vm.$t("Save")))]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                { attrs: { data: _vm.globalVariableList, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "key", label: _vm.$t("Key") }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "value", label: _vm.$t("Value") }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "remark", label: _vm.$t("Remark") }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "", label: _vm.$t("Action"), width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-delete",
                                type: "danger",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteGlobalVariableHandle(
                                    scope.row._id
                                  )
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }